import { RevenueAreaType } from '../../client-api.service';

export enum ExtendedRevenueAreaType {
  ConsolidatedUnitTypeAmenity = 'ConsolidatedUnitTypeAmenity'
}

export type AreaType = RevenueAreaType | ExtendedRevenueAreaType;
